/*
 * Title: GentleApi Obejct 
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

export default {
    type: {
        Bot: 'Bot',// '예정된 한달간의 스케줄을 확인해보세요.',
        Add: 'Add',// '스케줄 추가하기',
        Seminar: 'Seminar',// '세미나 일정 보기',
        SeminarBot: 'SeminarBot',// '한달간의 세미나 일정을 보여드릴게요.',
        SeminarApply: 'SeminarApply',// '세미나 참가신청하기',
        My: 'My',// '나의 스케줄 보기',
        NoLoginBot: 'NoLoginBot', //비로그인 파파 Bot
        NotFoundSchedule: 'NotFoundSchedule',
        },
    tomy:{
        kr: {
            Bot: '한 달간 예정된 스케줄을 보여드립니다. 스케줄을 놓치지 않도록 미리 확인하시면 좋습니다.',
            Add: '스케줄 추가하기',
            Seminar: '세미나 일정 보기',
            SeminarBot: '한 달간의 세미나 일정을 보여드립니다. 궁금한 세미나가 있다면 꼭 참가해보시는 걸 추천해 드립니다.',
            SeminarApply: '세미나 참가신청하기',
            My: '나의 스케줄 보기',
            NotFoundSchedule: '일정이 없습니다.',
        },
        eng: {
            Bot: "We'll show you what's scheduled for one month. It's recommended to check the schedule in advance so as not to miss an appointment!",
            Add: 'Add schedule',
            Seminar: 'View seminar schedule',
            SeminarBot: "We'll show you which seminars are scheduled for a month. If you have any questions about the seminar, then we recommend that you attend.",
            SeminarApply: 'Apply for seminar',
            My: 'View my schedule',
            NotFoundSchedule: 'No schedule.',

        }
    },
    papa:{
        kr: {
            NoLoginBot: '새로운 공지사항을 확인해보세요. 자주 체크하는 습관들 잘 들이고 있네요, 좋습니다!',
            Bot: '{name}님, 앞으로 한 달 동안 예정된 스케줄이에요.',
            Add: '스케줄 추가하기',
            Seminar: '세미나 일정 보기',
            SeminarBot: '한 달간 예정된 세미나예요. 세미나 참석이 애터미 사업 환경에 익숙해지는 데 도움이 많이 될 테니 우리 {name}님이 잘 활용해보면 좋겠어요.',
            SeminarApply: '세미나 참가신청하기',
            My: '나의 스케줄 보기',
            NotFoundSchedule: '일정이 없습니다.',

        },
        eng: {
            NoLoginBot: "Check out the new announcements. I'm getting into the habit of checking frequently, good!",
            Bot: '{name}, this is your schedule for the next month.',
            Add: 'Add schedule',
            Seminar: 'View seminar schedule',
            SeminarBot: "This seminar is scheduled for one month. Attending the seminar will help you get accustomed to Atomy's business environment, so I hope {name} will take advantage of it.",
            SeminarApply: 'Apply for seminar',
            My: 'View my schedule',
            NotFoundSchedule: 'No schedule.',

        }
    },
};
